// --- Bundled assets (formerly CDN <script>/<link> tags — now local for
//     offline launch + App Store review). ---
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './tailwind.generated.css'; // compiled by `npm run build:css` (prestart/prebuild)

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary'; // Import the boundary

// Components reference Leaflet via the window.L global (as they did with the
// unpkg script), so expose the bundled copy the same way.
window.L = L;

const root = ReactDOM.createRoot(document.getElementById('root'));

// WRAP THE APP HERE
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
